import React from "react";
import lodash from "lodash";
import { nullToEmptyString } from "./helper";

export const findChildren = (children, id, totalList) => {
  if (!totalList) return children;
  totalList.map((app) => {
    if (app.parentId === id) {
      children.unshift(app);
      findChildren(children, app.id, totalList);
    }
  });
};

export const getFlow = (flowId, flows) => {
  return flows.find((f) => f.id === flowId);
};
export const getActionName = (actionId, flow) => {
  if (!flow || !flow.actions) {
    return null;
  }
  const action = flow.actions.find((a) => a.id === actionId);
  return action ? action.name : null;
};

export const renderTree = (array, parent, tree) => {
  tree = typeof tree !== "undefined" ? tree : [];
  parent = typeof parent !== "undefined" ? parent : { id: null };

  if (parent.id) parent.hasChildren = false;

  var children = lodash.filter(array, function (child) {
    return child.parentId == parent.id;
  });

  if (!lodash.isEmpty(children)) {
    if (parent.id == null) {
      tree = children;
    } else {
      parent.hasChildren = true;
      parent["children"] = children;
    }
    lodash.each(children, function (child) {
      renderTree(array, child);
    });
  }

  return tree;
};

export const renderList = (list) => {
  if (!list) return [];
  const newList = list.map((item) => {
    item.hasChildren = false;
    item.id = item.key;
    return item;
  });
  return newList;
};
export const getSelectActionOptions = (actions, includeNone) => {
  let actionOptions = actions.map((a) => {
    return { label: a.name, value: a.id };
  });
  if (includeNone) {
    actionOptions.unshift({ label: "-None-", value: "" });
  }
  return actionOptions;
};
export const mergeCurrentActionToFlow = (action, flow) => {
  if (!flow) {
    return {};
  }
  const index = flow.actions.findIndex(a => a.id === action.id);

  if (index !== -1) {
    // Update the existing action
    flow.actions[index] = action;
  } else {
    // Add the new action if it doesn't exist
    flow.actions.push(action);
  }

  return { ...flow, actions: [...flow.actions] };
};
export const mergeCombinedCondition = (condition, combinedConditions) => {
  if (!combinedConditions) {
    return {};
  }
  const index = combinedConditions.conditions.indexOf(condition);
  combinedConditions.conditions[index] = condition;
  return combinedConditions;
};

const resolveParentId = (action, actions) => {
  const parentId = nullToEmptyString(action?.parentId);
  if (!parentId) {
    return "";
  }

  // Guard against self-referencing parents or missing references.
  if (action?.id === parentId) {
    return "";
  }

  const parentExists = actions.some((possibleParent) => possibleParent?.id === parentId);
  if (!parentExists) {
    return "";
  }

  const seen = new Set([action?.id]);
  let currentParentId = parentId;

  while (currentParentId) {
    if (seen.has(currentParentId)) {
      return "";
    }

    seen.add(currentParentId);

    const currentParent = actions.find((possibleParent) => possibleParent?.id === currentParentId);
    if (!currentParent) {
      return "";
    }

    currentParentId = nullToEmptyString(currentParent.parentId);
  }

  return parentId;
};

export const getActions = (flow, parent = "") => {
  if (!flow || !Array.isArray(flow.actions)) {
    return [];
  }

  const actionsWithResolvedParent = flow.actions.map((action) => ({
    ...action,
    parentId: resolveParentId(action, flow.actions),
  }));

  const actions = actionsWithResolvedParent.filter((action) => nullToEmptyString(action.parentId) === parent);
  return actions.sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER));
};

export const getAction = (flow, id) => {
  return flow?.actions ? flow?.actions.find((a) => a.id === id) : null;
};

export const isParent = (flow, action) => {
  return getActions(flow, action.id).length > 0;
};

export const isChild = (action) => {
  return nullToEmptyString(action.parentId) !== "";
};

export const isChildRecursiveCheck = (actions, childId, parentId, visited = new Set()) => {
  if (childId === parentId) {
    return true;
  }

  if (!parentId || visited.has(parentId)) {
    return false;
  }

  visited.add(parentId);

  for (const obj of actions) {
    if (obj.id === parentId) {
      return isChildRecursiveCheck(actions, childId, obj.parentId, visited);
    }
  }

  return false;
};

export const rotateActionAncestorChain = (actions, actionId, ancestorId) => {
  const actionsById = new Map(actions.map((action) => [action?.id, action]));
  const action = actionsById.get(actionId);
  const ancestor = actionsById.get(ancestorId);

  if (!action || !ancestor) {
    return false;
  }

  const chain = [];
  const visited = new Set();
  let currentAction = action;

  while (currentAction) {
    if (visited.has(currentAction.id)) {
      return false;
    }

    visited.add(currentAction.id);
    chain.push(currentAction);

    if (currentAction.id === ancestorId) {
      const ancestorParentId = nullToEmptyString(ancestor.parentId);
      action.parentId = ancestorParentId;

      let nextParentId = action.id;
      for (let index = chain.length - 1; index >= 1; index -= 1) {
        chain[index].parentId = nextParentId;
        nextParentId = chain[index].id;
      }

      return true;
    }

    currentAction = actionsById.get(nullToEmptyString(currentAction.parentId));
  }

  return false;
};
